module.exports = __webpack_public_path__ + "static/media/marker.cfd2cf7d.svg";